import {
  Button,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Table,
  Dialog,
  DialogTitle,
  Stack
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import moment from "moment";
import FileDownloadDoneIcon from "@mui/icons-material/FileDownloadDone";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import api from "../../../utils/Url";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { useNavigate, useLocation } from "react-router-dom";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";



type Props = {};

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "120vh",
  height: "60vh",
  bgcolor: "#f5f5f5",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: 10,
};

interface FileOption {
  value: number;
  fileName: string;
  fileNo?: string;
  synopsis: string;
  remark: string;
  totalPages: string;
  rfid: string;
  chackNo: string;
}

const UserFileMovement = (props: Props) => {
  const { i18n, t } = useTranslation();

  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValues = new Date(date).toISOString().split("T")[0];
  var defaultValuestime = new Date(date).toISOString();
  // console.log("defaultValuestime",defaultValuestime)

  const [memberOption, setMemberOption] = useState<any>([]);
  const [antina, setAntina] = useState<any>(0);

  const [epcNumber, setEPCNumber] = useState<any>("");
  const [fileDetails, setFileDetails] = useState<FileOption[] | any>([]);
  const [fileDetailsTableData, setFileDetailsTableData] = useState<any>([]);
  const [MovementTableData, setMovementTableData] = useState<any>([]);

  //FileDetails Tran section
  const [chakno, setChakNo] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileNo, setFileNo] = useState("");
  const [remark, setRemark] = useState("");
  const [rfid, setRFID] = useState("");
  const [synopsis, setSynopsis] = useState("");
  const [totalPages, setTotalPages] = useState("");

  const [isChecked, setIsChecked] = useState(false);

  const [LocationOption, setLocationOption] = useState<any>([
    { value: "-1", label: "Select To Location" },
  ]);

  const [departmentOption, setDepartmentOption] = useState<any>([
    { value: "-1", label: "Select Location" },
  ]);

  const [receiverName, setReceiverName] = useState("");
  const [senderName, setSenderName] = useState("");
  const [selectedLocationLabel, setSelectedLocationLabel] = useState("");
  const [fileIDs, setFileID] = useState("");

  const [isDefaultValueSet, setIsDefaultValueSet] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const [rowData, setRowData] = useState(null);
  const [toLocation, setTolocation] = useState("");
  const [receiverNames, setReceiverNames] = useState("");

  const [modalFileName, setModalFileName] = useState("");
  if (!isDefaultValueSet) {
    const defaultLocation = LocationOption.find(
      (option: any) => option.value === parseInt(synopsis)
    );

    if (defaultLocation) {
      setSelectedLocationLabel(defaultLocation.label);
      setIsDefaultValueSet(true);
    }
  }

  const handleChange = () => {
    setIsChecked(!isChecked);
    console.log(isChecked);
  };

  useEffect(() => {
    //fetchMemberData();
    getFileDtailsData();
    getLocation();
    getFileMovement();
    getDepartmentData();
  }, []);

  const getLocation = () => {
    const collectData = {
      id: -1,
    };
    api.post(`LocationItems/GetMappedLocation`, collectData).then((res) => {
      const arr = res.data.data.map((item: any) => ({
        label: item.location,
        value: item.id,
      }));
      setLocationOption(arr);
    });
  };

  const getFileDtailsData = async () => {
    const collectData = {
      fileID: -1,
      fileType: -1,
      fileGroup: -1,
      fileCategory: -1,
      fileClass: -1,
      fileSubject: -1,
      show: true,
      exportOption: "",
    };
    const response = await api.post(`FileDetail/GetFileDetails`, collectData);
    const arr: FileOption[] = response?.data?.data?.map((item: any) => ({
      value: item.fileID,
      fileName: item.fileName,
      fileNo: item.fileNo,
      currentLocation: item.currentLocation,
      remark: item.remark,
      totalPages: item.totalPages,
      rfid: item.rfid,
      chackNo: item.chackNo,
    }));

    // const filteredArr = arr.filter((item: any) => item.fileNo);

    setFileDetails(arr);
  };

  const fetchMemberData = (nodeID:any) => {
    console.log("nodeID ",nodeID)
    const collectData = {
      useR_ID: "-1",
      nodeId : nodeID==null?-1:nodeID
    };
    api.post(`NodePermission/GetUserByJudiction`, collectData).then((response) => {
      const arr = response.data.data.map((items: any) => ({
        label: `${items.firsT_NAME}  ${items.suR_NAME}`,
        value: items.useR_ID,
       // value: items.useR_ID,
      }));
      setMemberOption(arr);
    });
  };

  const getDepartmentData = () => {
    const collectData = {
      departmentId: -1,
    };
    api.post(`Department/GetDepartmentmaster`, collectData).then((response) => {
      const arr = [];
      for (let i = 0; i < response.data.data.length; i++) {
        arr.push({
          label: response.data.data[i]["departmentName"],
          value: response.data.data[i]["departmentId"],
        });
      }
      setDepartmentOption(arr);
    });
  };

  const handleReceiveData = async (value: any) => {
    console.log("log check");
    // console.log("log check", value);
    // console.log("log check", value.hid);
    const collectData = {
      hid: value.hid,
      fileNumber: value.fileNumber,
      receivedDate: defaultValuestime,
    };
    const response = await api.post(
      `FileMovementHistory/AddUpdateFileMovementHistory`,
      collectData
    );

    if (response.data.isSuccess) {
      toast.success("Received file : ", response.data.mesg);
      getFileMovement();
    } else {
      toast.error(response.data.mesg);
    }
  };

  const getFileMovement = () => {
    const collectData = {
      hid: -1,
      fileID: -1,
      fileNumber: "",
      fromLocation: "",
      toLocation: "",
      refId: -1,
      sender: "",
      receiver: "",
    };
    api
      .post(`FileMovementHistory/GetFileMovementHistory`, collectData)
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            fileNumber: res.data.data[index]["fileNumber"],
            hid: res.data.data[index]["hid"],
            fileDate: res.data.data[index]["fileDate"],
            fromLocation: res.data.data[index]["fromLocation"],
            toLocation: res.data.data[index]["toLocation"],
            sender: res.data.data[index]["sender"],
            senderName: res.data.data[index]["senderName"],
            receiver: res.data.data[index]["receiver"],
            receiverName: res.data.data[index]["receiverName"],
            receivedDate: res.data.data[index]["receivedDate"],
            refId: res.data.data[index]["refId"],
            fileID: res.data.data[index]["fileID"],
            transferDate: res.data.data[index]["transferDate"],
            isSame: res.data.data[index]["isSame"],
            fileName:res.data.data[index]["fileName"],
            throughBy:res.data.data[index]["throughBy"],
            nodeID:res.data.data[index]["nodeID"]
            
          });
        }
        setMovementTableData(arr);
      });
  };

  const handleOpenDialog = (row: any) => {
    console.log("Save log check", row);
    fetchMemberData(row.nodeID+"")
    setModalFileName(row.fileNumber);
    setRowData(row);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleTransferData = async (value: any) => {
    const collectData = {
      hid: value.hid,
      fileNumber: value.fileNumber,
      transferDate: defaultValuestime,
    };
    const response = await api.post(
      `FileMovementHistory/AddUpdateFileMovementHistory`,
      collectData
    );

    if (response.data.isSuccess) {
      toast.success("Received file : ", response.data.mesg);
      getFileMovement();
    } else {
      toast.error(response.data.mesg);
    }
  };

  const accept = async (rowData: any) => {
    console.log("log check", rowData);

    const collectData = {
      hid: -1,
      fileID: rowData.fileID,
      fileNumber: rowData.fileNumber,
      fromLocation: rowData.fromLocation,
      toLocation: toLocation,
      refId: rowData.refid,
      sender: rowData.sender,
      receiver: receiverNames,
      createdDate: defaultValues,
      fileDate: defaultValues,
      // transferDate:defaultValuestime
    };

    const collectDatatrasfer = {
      hid: rowData.hid,
      fileID: rowData.fileID,
      fileNumber: rowData.fileNumber,
    };
    handleTransferData(collectDatatrasfer);

    const response = await api.post(
      `FileMovementHistory/AddUpdateFileMovementHistory`,
      collectData
    );

    if (response.data.isSuccess) {
      toast.success(response.data.mesg);
      getFileMovement();
      handleCloseDialog();
    } else {
      toast.error(response.data.mesg);
    }

    // Close the modal after saving data
  };

  const addRow = () => {
    if (!fileDetails) {
      toast.error("Please  file details before adding a new row.");
      return;
    }

    const existingRow = fileDetailsTableData.find(
      (row: any) =>
        row.fileName === fileName &&
        row.fileNo === fileNo &&
        row.chakno === chakno &&
        row.rfid === rfid
    );

    if (existingRow) {
      // If the entry already exists, show an alert message
      alert("This entry already exists.");
      return;
    }

    const newRow = {
      id: fileDetailsTableData.length + 1,
      fileName: fileName,
      fileNo: fileNo,
      chakno: chakno,
      rfid: rfid,
      synopsis: selectedLocationLabel,
      totalPages: totalPages,
      remark: remark,
    };
    setFileDetailsTableData((prevTableData: any) => {
      const updatedTableData = [...prevTableData, newRow];
      console.log(newRow);
      return updatedTableData;
    });

    // setFileDetails("");
    setChakNo("");
    setFileName("");
    // setFileNo("");
    setRemark("");
    setRFID("");
    setSynopsis("");
    // setTotalPages("");
  };

  const reject = () => {
    toast.warn("Rejected: You have rejected", { autoClose: 3000 });
  };

  const handleConfirmClick = (rowData: any) => {
    confirmDialog({
      message: t("text.DoYouWantToDeleteThisRecord"),
      header: t("text.DeleteConfirmation"),
      icon: "pi pi-info-circle",
      acceptClassName: "p=-button-danger",
      //   accept(rowData: any),
      reject,
    });
  };

  let navigate = useNavigate();


  const routeChangeAdd = () => {
    let path = `/Library/FileMovement`;
    navigate(path);
  };

  const routeChangeEdit = (row: any) => {
    console.log("row " + row);
    console.log(JSON.stringify(row));

    let path = `/Library/FileMovementEdit`;
    navigate(path, {
      state: row,
    });
  };

  return (
    <div
      style={{
        padding: "-5px 5px",
        backgroundColor: "#ffffff",
        borderRadius: "5px",
        marginTop: "3vh",
        // border: ".5px solid #FF7722",
      }}
    >
      <CardContent>
        <Typography
          variant="h5"
          textAlign="center"
          style={{ fontSize: "18px", fontWeight: 500, marginBottom: "5px" }}
        >
          {t("text.UserFileMovement")}
        </Typography>

        <Divider />
        <br />
        <Stack direction="row" spacing={2} style={{marginBottom:"8px"}}>

        <Button
                onClick={routeChangeAdd}
                variant="contained"
                endIcon={<AddCircleIcon />}
                size="large"
              >
                {t("text.add")}
              </Button>
              </Stack>

        <form>
          <Grid item xs={12} sm={12} container spacing={2}>
            <Grid item xs={12} sm={12} container spacing={4}>
              {/* <Grid item xs={2}>
                                <Button
                                    fullWidth
                                    style={{
                                        backgroundColor: "#4990E2",
                                        color: "white",
                                        marginBottom: "10px",
                                    }}
                                    onClick={getFileMovement}
                                >
                                    <AddCircleOutlineIcon /> {" "}{t("text.add")}
                                </Button>
                            </Grid> */}

              <Grid container xs={12} spacing={2} sx={{ marginTop: "10px" }}>
                <Grid xs={12} sm={12} item>
                  <Table
                    style={{
                      borderCollapse: "collapse",
                      width: "97%",
                      border: "1px solid black",
                      marginLeft: "30px",
                    }}
                  >
                    <thead
                      style={{
                        backgroundColor: "#2196f3",
                        color: "#f5f5f5",
                      }}
                    >
                      <tr>
                      <th
                          style={{
                            borderLeft: "1px solid black",
                            paddingBlock: "10",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                            width: "100px",
                          }}
                        >
                          {t("text.Action")}
                        </th>
                        <th
                          style={{
                            borderLeft: "1px solid black",
                            paddingBlock: "10",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                            width: "100px",
                          }}
                        >
                          {t("text.FileName")}
                        </th>

                        <th
                          style={{
                            borderLeft: "1px solid black",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                            width: "100px",
                          }}
                        >
                          {t("text.FileDate")}
                        </th>
                        <th
                          style={{
                            borderLeft: "1px solid black",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                          }}
                        >
                          {t("text.FromLocation")}
                        </th>
                        <th
                          style={{
                            borderLeft: "1px solid black",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                            width: "100px",
                          }}
                        >
                          {t("text.ToLocation")}
                        </th>
                        <th
                          style={{
                            borderLeft: "1px solid black",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                          }}
                        >
                          {t("text.SenderName")}
                        </th>

                        <th
                          style={{
                            borderLeft: "1px solid black",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                          }}
                        >
                          {t("text.ReceiverName")}
                        </th>

                        <th
                          style={{
                            borderLeft: "1px solid black",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                          }}
                        >
                          {t("text.ReceivedDate")}
                        </th>

                        <th
                          style={{
                            borderLeft: "1px solid black",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                          }}
                        >
                          {t("text.Action")}
                        </th>
                      </tr>
                    </thead>
                    <tbody style={{ border: "1px solid black" }}>
                      {MovementTableData.map((row: any, index: any) => (
                        <tr key={row.id} style={{ border: "1px solid black" }}>
                          <td
                            style={{
                              borderLeft: "1px solid black",
                              borderTop: "1px solid black",
                              textAlign: "center",
                              padding:"2px"
                            }}
                          >
                            {    row.isSame == true && row.receivedDate === null ?  
                            <EditIcon
                      style={{
                        fontSize: "20px",
                        color: "blue",
                        cursor: "pointer",
                      }}
                      className="cursor-pointer"
                      onClick={() => routeChangeEdit(row)}
                    />:""  }

                            {/* {row} */}
                          </td>
                          
                          <td

                            style={{
                              borderLeft: "1px solid black",
                              borderTop: "1px solid black",
                              // textAlign: "center",
                              padding:"2px"
                            }}
                          >
                            {row.fileName}
                          </td>

                          <td
                            style={{
                              borderLeft: "1px solid black",
                              borderTop: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            {moment(row.fileDate).format("DD-MM-YYYY")}
                          </td>

                          <td
                            style={{
                              borderLeft: "1px solid black",
                              borderTop: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            {row.fromLocation}
                          </td>

                          <td
                            style={{
                              borderLeft: "1px solid black",
                              borderTop: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            {row.toLocation}
                          </td>

                          <td
                            style={{
                              borderLeft: "1px solid black",
                              borderTop: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            {row.senderName}
                          </td>

                          <td
                            style={{
                              borderLeft: "1px solid black",
                              borderTop: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            {row.receiverName}
                            {/* <p onClick={handleReceiveData}>{row.receiver}</p> */}
                          </td>

                          <td
                            style={{
                              borderLeft: "1px solid black",
                              borderTop: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            {/* {row.receivedDate === null ? (<><FileDownloadDoneIcon/></>):(<>moment(row.receivedDate).format("DD-MM-YYYY")</>)} */}
                            {row.receivedDate === null ? (
                              <>--</>
                            ) : (
                              <>
                                {moment(row.receivedDate).format("DD-MM-YYYY")}
                              </>
                            )}
                          </td>
                          <td
                            style={{
                              borderLeft: "1px solid black",
                              // borderTop: "1px solid black",
                              textAlign: "center",
                              display: "flex",
                              justifyContent: "space-around",
                              alignItems: "center",
                            }}
                          >
                            {row.transferDate != null ? (
                              <>File Sent</>
                            ) : (
                              <>
                                <span>
                                  {
                                  
                                  row.receivedDate === null ? (
                                    row.isSame == true ?  (
                                      <>File will receive by Receiver only</>
                                    ) : (
                                      <Button
                                        style={{
                                          backgroundColor: "#4990E2",
                                          color: "white",
                                          margin: "5px",
                                        }}
                                        onClick={(e: any) =>
                                          handleReceiveData(row)
                                        }
                                      >
                                        {t("text.Receive")}
                                      </Button>
                                    )
                                  ) : (  row.isSame !=true ?(
                                    <FileDownloadDoneIcon
                                      color="success"
                                      sx={{ width: "80px" }}
                                    />
                                  ):<><span style={{textAlign:"center"}}> File Received </span>   </>)}
                                </span>
                                {
                                row.receivedDate && (
                                  row.isSame !=true && (<Button
                                    style={{
                                      backgroundColor: "#4990E2",
                                      color: "white",
                                      margin: "5px",
                                    }}
                                    onClick={(e: any) => handleOpenDialog(row)}
                                  >
                                    {t("text.Send")}
                                  </Button>)
                                )}
                              </>
                            )}

                           
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

                  <Modal open={openDialog} onClose={handleCloseDialog}>
                    <Box sx={style}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <DialogTitle sx={{ marginBottom: "5px" }}>
                          Send User File Movement
                        </DialogTitle>

                        <DialogTitle sx={{ marginBottom: "5px" }}>
                          #{modalFileName}
                        </DialogTitle>
                      </div>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        container
                        spacing={4}
                        marginBottom={5}
                      >
                        <Grid item lg={4} xs={12}>
                          <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={memberOption}
                            //   getOptionLabel={(option: any) => option.empName}
                            fullWidth
                            size="small"
                            onChange={(event, newValue: any) => {
                              console.log(newValue?.value);
                              console.log("Selected value:", newValue);
                              setReceiverNames(newValue?.value);

                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Receiver Name"
                              />
                            )}
                          />
                        </Grid>

                        {/* <Grid item lg={4} xs={12}>
                          <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={departmentOption}
                            //getOptionLabel={(option: any) => option.empName}
                            //value={departmentOption.find(x=>x.value==toLocation)}
                            value={
                              departmentOption.find(
                                  (option:any) => option.value === toLocation
                              ) || null
                          }
                            fullWidth
                            size="small"
                            onChange={(event, newValue: any) => {
                              console.log(newValue?.value);
                              console.log("Selected value:", newValue);
                              setTolocation(newValue?.label);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select To Location"
                              />
                            )}
                          />
                        </Grid> */}
                      </Grid>
                      <Grid container item xs={12}>
                        <Button
                          fullWidth
                          style={{
                            backgroundColor: "#4990E2",
                            color: "white",
                            marginBottom: "10px",
                            marginRight: "10px",
                            marginLeft: "10px",
                            width: "47%",
                          }}
                          onClick={() => accept(rowData)}
                        >
                          Save
                        </Button>
                        <Button
                          style={{
                            backgroundColor: "#059669",
                            color: "white",
                            marginBottom: "10px",
                            width: "47%",
                          }}
                        >
                          Reset
                        </Button>
                      </Grid>
                    </Box>
                  </Modal>
                </Grid>
              </Grid>

              <br />
            </Grid>
          </Grid>
        </form>
      </CardContent>
      <ToastApp />
    </div>
  );
};

export default UserFileMovement;
